import { useState } from 'react';
import AlertBox from '../../components/ui/AlertBox';
import { useQuizzes } from '../../contexts/QuizContext';
import QuizModal from '../../components/modals/QuizModal';
import QuizDisplayCard from '../../components/ui/QuizDisplayCard';

function LecturerQuizzesPage() {
    let { quizzes, loading, error } = useQuizzes()
    const [showCreateModal, setShowCreateModal] = useState(false);

    const handleNewQuiz = (newQuiz) => {
        console.log('Quiz created:', newQuiz);
        // Optional: trigger refetch or add to local state
    };

    return (
        <div className="max-w-4xl p-6">

            <div className="mb-10 flex justify-between items-center">
                <h1 className="text-2xl font-semibold text-gray-800 text-center self-end">
                    Your Quizzes
                </h1>
                <button className="btn btn-primary" onClick={() => setShowCreateModal(true)}>
                    + Create Quiz
                </button>
            </div>

            {loading ? (
                <div className="text-center italic text-gray-600">Loading quizzes...</div>
            ) : error ? (
                <AlertBox message={error} />
            ) : quizzes.length === 0 ? (
                <div className="mt-4 text-center">
                    <h3 className="text-4xl">😒</h3>
                    <div className="text-gray-600 text-lg">You haven't created any Quiz yet.</div>
                </div>
            ) : (
                <ul className="list-none p-0 space-y-2">
                    {quizzes.map((quiz) => (
                       <QuizDisplayCard key={quiz.id} quiz={quiz}/>
                    ))}
                </ul>
            )}

            <QuizModal
                isOpen={showCreateModal}
                onClose={() => setShowCreateModal(false)}
                onSuccess={handleNewQuiz}
            />
        </div>
    );
}

export default LecturerQuizzesPage;